import {PropositionList} from "components/front/PMS/Proposition/List/PropositionList"
import React from "react"

export const PropositionListRoute = () => {
  return <div>
    <h1>Liste des propositions</h1>
    <PropositionList />
  </div>
}